import styles from "./MetricCard.module.css";
import type { MetricCardProps } from "./MetricCard.types";

export function MetricCard({ icon, label, value, prefix, className }: MetricCardProps) {
  return (
    <div className={[styles.metric, className].filter(Boolean).join(" ")}>
      <img
        className={styles.icon}
        src={icon}
        alt=""
        width={64}
        height={64}
        aria-hidden
        loading="lazy"
        decoding="async"
      />
      <div className={styles.card}>
        <span className={styles.label}>{label}</span>
        <div className={styles.valueRow}>
          {prefix && <span className={styles.prefix}>{prefix}</span>}
          <span className={styles.value}>{value}</span>
        </div>
      </div>
    </div>
  );
}
